export default function (options) {
    var container = options.container, _options$audio = options.audio, audio = _options$audio === void 0 ? {} : _options$audio, _options$options = options.options, _options$options2 = _options$options === void 0 ? {} : _options$options, _options$options2$aut = _options$options2.autoplay, autoplay = _options$options2$aut === void 0 ? false : _options$options2$aut, _options$options2$loo = _options$options2.loop, loop = _options$options2$loo === void 0 ? false : _options$options2$loo, _options$options2$vol = _options$options2.volume, volume = _options$options2$vol === void 0 ? 0.7 : _options$options2$vol;
    if (!container) {
        throw new Error('SPlayer.js: Missing container parameter.');
    }
    var _audio$title = audio.title, title = _audio$title === void 0 ? 'Unknown' : _audio$title, _audio$artist = audio.artist, artist = _audio$artist === void 0 ? 'Unknown' : _audio$artist, url = audio.url, _audio$cover = audio.cover, cover = _audio$cover === void 0 ? '' : _audio$cover;
    if (!url || typeof url !== 'string' || url === '') {
        throw new Error('SPlayer.js: Missing audio url.');
    }
    return {
        container: container,
        options: {
            autoplay: autoplay,
            loop: loop,
            volume: volume
        },
        audio: {
            title: title,
            artist: artist,
            url: url,
            cover: cover
        }
    };
};